import { render } from "./ReceberValores.vue?vue&type=template&id=239b243a&lang=pug"
import script from "./ReceberValores.vue?vue&type=script&setup=true&lang=js"
export * from "./ReceberValores.vue?vue&type=script&setup=true&lang=js"

import "./ReceberValores.vue?vue&type=style&index=0&id=239b243a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__